const formatError = (type, extra) => {
  if (!extra) {
    return new Error(type);
  }
  return new Error(`${type}: ${JSON.stringify(extra)}`);
};
export {
  formatError
};
